export enum ApiChatMessageType {
  User = 'USER',
  Assistant = 'ASSISTANT',
}
